// import React, { useState, useEffect, useRef } from "react";
// import { Button, Input, Modal } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { LogoutAction } from "@store/auth/actions";
// import { apiPost } from "api/callApi";
// import CryptoJS from "crypto-js";
// import SC from "./style.js";
// import {
//   readFromLocalStorage,
//   saveToLocalStorage,
// } from "utils/helper/index.js";
// import Googlesignin from "views/googlelogin/index.jsx";

// const { REACT_APP_CRYPTO_KEY, REACT_APP_API_KEY, REACT_APP_TIMOEOUT } =
//   process.env;

// const encryptPassword = (password) => {
//   return CryptoJS.AES.encrypt(password, REACT_APP_CRYPTO_KEY).toString();
// };

// const SessionTimeout = () => {
//   const [showModal, setShowModal] = useState(() =>
//     readFromLocalStorage("showModal") == true ? true : false
//   );
//   const [password, setPassword] = useState("");
//   const [loading, setLaoding] = useState(false);
//   const [isError, setIsError] = useState(false);
//   const TIMEOUT_DURATION = REACT_APP_TIMOEOUT * 60 * 1000;
//   // let timeout;
//   const timeout = useRef(null); // for inactivity
//   const logoutTimeout = useRef(null); // for modal timeout

//   const { data = {} } = useSelector((state) => state.authdata);

//   useEffect(() => {
//     setPassword("");
//     setIsError(false);
//     setLaoding(false);
//   }, [showModal]);

//   const dispatch = useDispatch();

//   const resetTimeout = () => {
//     if (timeout.current) clearTimeout(timeout.current);
//     timeout.current = setTimeout(() => {
//       setShowModal(true);
//       saveToLocalStorage("showModal", true);
//       // Start a logout countdown once modal is shown (e.g., 1 minute)
//       logoutTimeout.current = setTimeout(() => {
//         handleLogout();
//       }, 60 * 1000);
//     }, TIMEOUT_DURATION);
//   };

//   const handleReLogin = () => {
//     if (timeout.current) clearTimeout(timeout.current);
//     if (logoutTimeout.current) clearTimeout(logoutTimeout.current);
//     setShowModal(false);
//     saveToLocalStorage("showModal", false);
//     resetTimeout();
//     setPassword("");
//   };

//   useEffect(() => {
//     const handleActivity = () => resetTimeout();
//     window.addEventListener("mousemove", handleActivity);
//     window.addEventListener("keydown", handleActivity);
//     resetTimeout();
//     return () => {
//       clearTimeout(timeout.current);
//       clearTimeout(logoutTimeout.current);
//       window.removeEventListener("mousemove", handleActivity);
//       window.removeEventListener("keydown", handleActivity);
//     };
//   }, []);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLaoding(true);
//     setIsError(false);
//     const tempUserData = {
//       userName: data.userName,
//     };
//     try {
//       if (password !== "") {
//         const encryptpass = encryptPassword(password);
//         tempUserData.password = encryptpass;
//       }
//       const response = await apiPost("/v1/login", tempUserData);
//       if (response) {
//         const { auth_key = "", data = {} } = response;
//         saveToLocalStorage("currentUser", JSON.stringify(data));
//         saveToLocalStorage("userAccessToken", auth_key || REACT_APP_API_KEY);
//         handleReLogin();
//       }
//       setLaoding(false);
//     } catch (err) {
//       console.log(err);
//       setLaoding(false);
//       setIsError(true);
//     }
//   };

//   const handleLogout = () => {
//     dispatch(LogoutAction());
//   };

//   return (
//     <Modal
//       title="Session Expired"
//       open={showModal}
//       zIndex={10000}
//       footer={null}
//       closable={false}
//     >
//       <Googlesignin setShowModal={setShowModal} handleReLogin={handleReLogin} />
//       <p>Please provide your password to continue.</p>
//       <form onSubmit={handleLogin}>
//         <div style={{ marginBottom: "16px" }}>
//           <label
//             style={{
//               display: "block",
//               fontWeight: "bold",
//               marginBottom: "8px",
//             }}
//           >
//             Username
//           </label>
//           <Input
//             value={data?.userName || ""}
//             disabled
//             style={{ backgroundColor: "#f5f5f5", cursor: "not-allowed" }}
//           />
//         </div>

//         <div style={{ marginBottom: "16px" }}>
//           <label
//             style={{
//               display: "block",
//               fontWeight: "bold",
//               marginBottom: "8px",
//             }}
//           >
//             Password
//           </label>
//           <Input.Password
//             placeholder="Enter your password"
//             onChange={(e) => {
//               setPassword(e.target.value);
//             }}
//             value={password}
//           />
//         </div>

//         {isError && (
//           <span style={{ fontSize: "11px", color: "red" }}>
//             Invalid credentials, please try again.
//           </span>
//         )}

//         <div
//           style={{
//             textAlign: "center",
//             flexDirection: "column",
//             display: "flex",
//           }}
//         >
//           <SC.Button type="submit" disabled={loading}>
//             {loading ? "Sign in.." : "Sign in"}
//           </SC.Button>
//           or
//           <span
//             onClick={handleLogout}
//             style={{ color: "red", marginTop: "5px", cursor: "pointer" }}
//           >
//             <u>Logout</u>
//           </span>
//         </div>
//       </form>
//     </Modal>
//   );
// };

// export default SessionTimeout;

import React, { useState, useEffect, useRef } from "react";
import { Button, Input, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { LogoutAction } from "@store/auth/actions";
import { apiPost } from "api/callApi";
import CryptoJS from "crypto-js";
import SC from "./style.js";
import {
  readFromLocalStorage,
  saveToLocalStorage,
} from "utils/helper/index.js";
import Googlesignin from "views/googlelogin/index.jsx";

const { REACT_APP_CRYPTO_KEY, REACT_APP_API_KEY, REACT_APP_TIMOEOUT } =
  process.env;

const encryptPassword = (password) => {
  return CryptoJS.AES.encrypt(password, REACT_APP_CRYPTO_KEY).toString();
};

const SessionTimeout = () => {
  const [showModal, setShowModal] = useState(
    () => readFromLocalStorage("showModal") === true
  );
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const TIMEOUT_DURATION = REACT_APP_TIMOEOUT * 60 * 1000;

  const timeout = useRef(null);
  const logoutTimeout = useRef(null);
  const lastActivityBroadcast = useRef(0);

  const { data = {} } = useSelector((state) => state.authdata);
  const dispatch = useDispatch();

  useEffect(() => {
    setPassword("");
    setIsError(false);
    setLoading(false);
  }, [showModal]);

  const resetTimeout = (broadcast = true) => {
    if (timeout.current) clearTimeout(timeout.current);

    timeout.current = setTimeout(() => {
      setShowModal(true);
      saveToLocalStorage("showModal", true);
      localStorage.setItem("session-expired", Date.now());

      logoutTimeout.current = setTimeout(() => {
        handleLogout();
      }, 60 * 1000); // 1 min to logout after modal shows
    }, TIMEOUT_DURATION);

    if (broadcast) {
      localStorage.setItem("user-activity", Date.now()); // sync activity
    }
  };

  const handleReLogin = () => {
    clearTimeout(timeout.current);
    clearTimeout(logoutTimeout.current);
    setShowModal(false);
    saveToLocalStorage("showModal", false);
    localStorage.setItem("user-activity", Date.now());
    localStorage.removeItem("session-expired");
    resetTimeout();
    setPassword("");
  };

  const handleActivity = () => {
    const now = Date.now();
    const shouldBroadcast = now - lastActivityBroadcast.current > 1000;
    if (shouldBroadcast) {
      lastActivityBroadcast.current = now;
    }
    resetTimeout(shouldBroadcast);
  };

  const handleStorageChange = (e) => {
    if (e.key === "user-activity") {
      resetTimeout(false); // Another tab was active
    }

    if (e.key === "session-expired") {
      setShowModal(true);
      logoutTimeout.current = setTimeout(() => {
        handleLogout();
      }, 60 * 1000);
    }
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("storage", handleStorageChange);

    resetTimeout(); // on mount

    return () => {
      clearTimeout(timeout.current);
      clearTimeout(logoutTimeout.current);
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setIsError(false);

    const tempUserData = {
      userName: data.userName,
    };

    try {
      if (password !== "") {
        const encryptpass = encryptPassword(password);
        tempUserData.password = encryptpass;
      }

      const response = await apiPost("/v1/login", tempUserData);
      if (response) {
        const { auth_key = "", data = {} } = response;
        saveToLocalStorage("currentUser", JSON.stringify(data));
        saveToLocalStorage("userAccessToken", auth_key || REACT_APP_API_KEY);
        handleReLogin();
      }

      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
      setIsError(true);
    }
  };

  const handleLogout = () => {
    dispatch(LogoutAction());
  };

  return (
    <Modal
      title="Session Expired"
      open={showModal}
      zIndex={10000}
      footer={null}
      closable={false}
    >
      <Googlesignin setShowModal={setShowModal} handleReLogin={handleReLogin} />
      <p>Please provide your password to continue.</p>
      <form onSubmit={handleLogin}>
        <div style={{ marginBottom: "16px" }}>
          <label
            style={{
              display: "block",
              fontWeight: "bold",
              marginBottom: "8px",
            }}
          >
            Username
          </label>
          <Input
            value={data?.userName || ""}
            disabled
            style={{ backgroundColor: "#f5f5f5", cursor: "not-allowed" }}
          />
        </div>

        <div style={{ marginBottom: "16px" }}>
          <label
            style={{
              display: "block",
              fontWeight: "bold",
              marginBottom: "8px",
            }}
          >
            Password
          </label>
          <Input.Password
            placeholder="Enter your password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
        </div>

        {isError && (
          <span style={{ fontSize: "11px", color: "red" }}>
            Invalid credentials, please try again.
          </span>
        )}

        <div
          style={{
            textAlign: "center",
            flexDirection: "column",
            display: "flex",
          }}
        >
          <SC.Button type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </SC.Button>
          or
          <span
            onClick={handleLogout}
            style={{ color: "red", marginTop: "5px", cursor: "pointer" }}
          >
            <u>Logout</u>
          </span>
        </div>
      </form>
    </Modal>
  );
};

export default SessionTimeout;
